// extracted by mini-css-extract-plugin
export default {"SocialButton":"SocialButton_SocialButton__7D58H","image":"SocialButton_image__J9NEZ","text":"SocialButton_text__mlkZy"};